import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from './assets/images/backgrounds/home.jpg'
import _imports_1 from './assets/images/backgrounds/water-activities.jpg'
import _imports_2 from './assets/images/backgrounds/land-activities.jpg'
import _imports_3 from './assets/images/backgrounds/team-building.jpg'
import _imports_4 from './assets/images/backgrounds/about-us.jpg'
import _imports_5 from './assets/images/backgrounds/contact.jpg'


const _hoisted_1 = /*#__PURE__*/_createStaticVNode("<div id=\"preload\" style=\"display:none;\"><img src=\"" + _imports_0 + "\"><img src=\"" + _imports_1 + "\"><img src=\"" + _imports_2 + "\"><img src=\"" + _imports_3 + "\"><img src=\"" + _imports_4 + "\"><img src=\"" + _imports_5 + "\"></div>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_Footer = _resolveComponent("Footer")!

  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _createVNode(_component_Header),
    _createVNode(_component_router_view),
    _createVNode(_component_Footer)
  ]))
}